import { Cols, ESectors } from "../shared/Consts";
import Utils from "../portlibs/PortUtils";
import Holding from "./Holding";

export default class PerformanceRow {
    sector:ESectors
    currency:number = 0
    dividend:number = 0
    gain:number = 0
    holdingCost:number = 0
    holdingValue:number = 0
    holdingPercent:number = 0
    holdingPortion:number = 0;
    holdings:Holding[] = []
    constructor(sector:ESectors){
        this.sector = sector;
    }
    value(col:string) : string{
        switch(col){
        case Cols.sector:           return Utils.sector(this.sector)
        case Cols.holdingCost:      return Utils.formatCurrency(0, this.holdingCost);
        case Cols.holdingValue:     return Utils.formatCurrency(0, this.holdingValue);
        case Cols.dividend:         return Utils.formatCurrency(0, this.dividend);
        case Cols.gain:             return Utils.formatCurrency(0, this.gain);
        case Cols.holdingPercent:   return Utils.formatPercent(this.holdingPercent);
        case Cols.holdingPortion:   return Utils.formatPercent(this.holdingPortion);
        default:                    return "";
        }
    }
    tooltip(col:string){
        if (col==Cols.sector) return this.holdings.map(h => h.name).join(", ")
        else return ""
    }
    compValue(col:string) : number|string { return (this as any)[col] }
    addHolding(holding:Holding, portion:number){
        const exchange = holding.exchange;
        this.holdingCost += holding.holdingCost * portion * exchange;
        this.holdingValue += holding.holdingValue * portion * exchange;
        this.dividend += holding.dividend * portion * exchange;
        this.gain += holding.gain * portion * exchange;
        this.holdings.push(holding)
    }
}